class VideoModal extends window.Modal {
  isLoaded = false

  // Check for reduced motion preference
  prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

  close() {
    super.close()
    // find the video
    const video = this.querySelector('video')

    if (video) {
      // reset the video
      video.currentTime = 0
      video.pause()
    }
  }

  async open() {
    super.open()
    if (!this.isLoaded) {
      const template = this.querySelector('template') // Assuming the <template> is a direct child of the FilterDrawer
      if (template) {
        const content = template.content.cloneNode(true)
        this.appendChild(content)
      }
      this.isLoaded = true
    }
    // find the video
    const video = this.querySelector('video')
    if (video) {
      // Wait for the video to load
      await video.load()

      // Respect prefers-reduced-motion preference
      if (this.prefersReducedMotion.matches) {
        return
      }

      // Play the video with error handling for autoplay restrictions
      try {
        await video.play()
      } catch (error) {
        // Autoplay was prevented - this is expected in some browsers
        if (error.name !== 'AbortError') {
          console.warn('Video autoplay was prevented:', error.message)
        }
      }
    }
  }
}

window.customElements.define('video-modal', VideoModal)
